
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import { _printDate, _printShortFullDate, _printNumber } from '../../helpers/helpers.js'
import CveTitle from '../../components/cveTitle.js'

import {RtCVEInfo, RtCVEsPageResult} from '../../../../server/routes/cve.js'

interface CVEsProps {
	server: string;
	pageData: unknown;
}

export default function CVEs({ server, pageData }: CVEsProps) {

    let [data, setData] = useState(pageData as RtCVEsPageResult);

    return (
        <>
            <CVESearch props={data} />
            <CVEBody props={data} />
        </>
    )
}


function CVESearch({ props }: { props: RtCVEsPageResult }) {
    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
        var q = document.getElementById('q') as HTMLInputElement;
        let t = String(q.value).trim();
        let cve = t.match(/^CVE-\d\d\d\d-\d+$/gi);
        if (cve != null) {
            document.location = '/cve/' + cve[0].toUpperCase();
        } else {
            cve = t.match(/^\d\d\d\d-\d+$/gi);
            if (cve != null) {
                document.location = '/cve/CVE-' + cve[0];
            } else {
                // reject form submission
            }
        }
    }

    return (
        <section className="section section-sm text-center">
            <div className="container">
                <div className="text-center">
                    <h2>CVE Lookup</h2>
                    <p>
                        <span style={{ maxWidth: '690px' }}>
                            Search Common Vulnerabilities and Exposures (CVE) by number.
                        </span>
                    </p>
                </div>

                <div>
                    <form className="rd-form rd-search form-inline" action="search" method="GET" onSubmit={handleSubmit}>
                        <div className="form-wrap">
                            <input required type="text" className="form-input" title="Lookup CVE by number" placeholder="Lookup CVE (for example 2022-43490 or CVE-2022-43490)" name="q" id="q" />
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit" >Search</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}

function CVEBody({ props }: { props: RtCVEsPageResult }) {
    return (
        <>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">             
                        <div className="col-md-12 col-lg-12 col-xl-12">
                           <CVEList title='Latest CVEs' list={props.MostRecentCVEs} link='/cve/latest' 
                                button='See complete list of latest CVEs'/>
                        </div>
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <CVEList title='List of the most common Common Vulnerabilities and Exposures (CVEs)' list={props.BiggestDomainCountCVEs}
                                link='/cve/all' button='See complete CVE list' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
};


interface CVEListProps {
	title: string;
	list: RtCVEInfo[];
	link: string;
	button: string;
}

function CVEList({ title, list, link, button }: CVEListProps) {

    return (
        <>
            <h4>{title}</h4>
            <br />
            <div className="table-outer table-rounded table-responsive-lg">
                <table className="table-custom table-custom-striped table-custom-primary  ">
                    <thead>
                        <tr>
                            <th style={{ width: '15%' }}>Published</th>
                            <th style={{ width: '20%' }}>CVE</th>
                            <th style={{ width: '55%' }}>Title</th>
                            <th style={{ width: '10%' }}>Domains</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            list.map((cve, indexKey) => {
                                return (
                                    <CVERow cve={cve} key={indexKey} />
                                )
                            })
                        }
                    </tbody>
                </table>
                <Link
                    to={link}
                    className="button button-secondary"
                    title={button}
                    rel="noopener nofollow"
                >
                    {button}
                </Link>
            </div>

        </>
    )
}

/*
function CVERow({cve, requireAuthentication}) {
        let techInfo = cve.CVETechnologyInfo;
        // icon, tech, version, category, date, count
        return (
        <>
        <tr>									
            <TechnologySmallIcon 
                    technologyIcon={techInfo.Icon} 
                    technology={techInfo.ShortName}
            />
            <b>
            {' '}{techInfo.ShortName}
            </b> 
                <td>
                    <Link 
                        to={`/technology/${techInfo.URL}/versions`} 
                        className="link-hover" 
                        title={`Show all versions of ${techInfo.ShortName}`}
                    >
                        {techInfo.Version}
                    </Link>                
                </td>
                <td>
                    {_printNumber(cve.DomainCount)}
                </td>
        </tr>		
        </>
)
}

*/
interface CVERowProps {
	cve: RtCVEInfo;
	requireAuthentication?: boolean;
}

function CVERow({ cve, requireAuthentication }: CVERowProps) {
    // icon, tech, version, category, date, count
    return (
        <>
            <tr>
            <td>
                    {_printShortFullDate(cve.Discovered)}
                </td>
                <td>
                    {cve.CVEId}
                </td>
                <td>
                    <Link
                        to={`/cve/${cve.CVEId}`}
                        className="link-hover"
                    >
                        <CveTitle cve={cve} />
                    </Link>
                </td>
                <td>
                    {_printNumber(cve.DomainCount)}
                </td>
            </tr>
        </>
    )
}
